import React from 'react'
import styled from 'styled-components'
const ButtonStyle= styled.button`
  background-color:#e51e25;
  font-size:18px;
  color:#fff;
  font-family: bold;
  padding: 5px 6px;
  border: 0 !important;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
`
const CloseStyle= styled.button`
    font-size:15px;
    border: 0 !important;
    color: #000;
    background:none;
`;
const Buttons = ({label,onClick,fullWidth,disabled,className}) => {
  return (
    <>
      <ButtonStyle onClick={onClick} fullWidth={fullWidth} disabled={disabled} className={className}>{label}</ButtonStyle>
    </>
  )
}
const Close = ({label,onClick}) => {
  return (
    <>
      <CloseStyle onClick={onClick}>{label}</CloseStyle>
    </>
  )
}

export{Buttons,Close} 